import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "products-overview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_search_modal = _resolveComponent("product-search-modal")!
  const _component_product_search = _resolveComponent("product-search")!
  const _component_products_list = _resolveComponent("products-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_product_search_modal),
    _createVNode(_component_product_search, {
      "search-value": _ctx.searchValue,
      "onUpdate:searchValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
      "selected-categories": _ctx.selectedCategories,
      "onUpdate:selectedCategories": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCategories) = $event)),
      "category-search": _ctx.categorySearch,
      "onUpdate:categorySearch": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.categorySearch) = $event)),
      "selected-brands": _ctx.selectedBrands,
      "onUpdate:selectedBrands": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedBrands) = $event)),
      "brand-search": _ctx.brandSearch,
      "onUpdate:brandSearch": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.brandSearch) = $event)),
      "recent-products": _ctx.recentProducts,
      "onUpdate:recentProducts": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.recentProducts) = $event)),
      categories: _ctx.categories,
      brands: _ctx.brands
    }, null, 8, ["search-value", "selected-categories", "category-search", "selected-brands", "brand-search", "recent-products", "categories", "brands"]),
    _createVNode(_component_products_list, {
      loading: _ctx.loading,
      "paginated-products": _ctx.filteredProducts,
      page: _ctx.currPage,
      "max-page": 5,
      "page-size": _ctx.pageSize,
      "product-total": _ctx.productTotal,
      onAddProduct: _ctx.addProduct,
      "onUpdate:page": _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPage($event))),
      onSetRecentProduct: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setRecentlyVisitedProducts($event)))
    }, null, 8, ["loading", "paginated-products", "page", "page-size", "product-total", "onAddProduct"])
  ]))
}